import React from "react";
import { ChevronDownIcon, ChevronRightIcon } from "lucide-react";
const stageColors = ["bg-stage-green", "bg-stage-orange", "bg-stage-red", "bg-stage-purple", "bg-stage-blue"];
type FlowStepsProps = {
  steps: string[];
  tone?: "light" | "dark";
  className?: string;
};
export function FlowSteps({
  steps,
  tone = "light",
  className = ""
}: FlowStepsProps) {
  const dark = tone === "dark";
  return <ol className={`mx-auto flex w-full max-w-3xl flex-col items-stretch md:flex-row md:items-start ${className}`} data-id="element-39" data-mp="2zmyxj5lyd4q7">
      {steps.map((step, i) => <li key={step} className="flex flex-col items-center md:flex-1 md:flex-row md:items-start" data-id="element-40" data-mp="34oelp6jffrct" data-mpi={i}>
          <div className={`flex w-full items-center gap-3 rounded-xl px-4 py-3 md:flex-col md:gap-2 md:bg-transparent md:px-1 md:py-0 md:ring-0 ${dark ? "bg-white/10 ring-1 ring-white/15" : "bg-white ring-1 ring-ink/10"}`} data-id="element-41" data-mp="2pvl33c8uyv3x">
            <span className={`grid h-10 w-10 shrink-0 place-items-center rounded-full text-base font-bold text-white md:h-12 md:w-12 ${stageColors[i % stageColors.length]}`} data-id="element-42" data-mp="3nee27517by4m">
              {i + 1}
            </span>
            <span className={`text-base font-bold uppercase tracking-wider ${dark ? "text-cream" : "text-ink"}`} data-id="element-43" data-mp="2g8bu2zpgozw">{step}</span>
          </div>
          {i < steps.length - 1 && <>
              <ChevronDownIcon className={`my-1 h-5 w-5 md:hidden ${dark ? "text-cream/50" : "text-ink/35"}`} aria-hidden="true" data-id="element-44" data-mp="cefo48j1uivk" />
              <ChevronRightIcon className={`mt-3.5 hidden h-5 w-5 shrink-0 md:block ${dark ? "text-cream/50" : "text-ink/35"}`} aria-hidden="true" data-id="element-45" data-mp="l92qevtf2f3l" />
            </>}
        </li>)}
    </ol>;
}